module.exports = __webpack_public_path__ + "static/media/22.7c2f1c83.webp";